import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
export function ClosingSection() {
  return <Section className="pb-32" data-id="element-14">
      <div className="max-w-xl mx-auto text-center space-y-8" data-id="element-15">
        <p className="text-xl md:text-2xl font-serif text-cream-50 leading-relaxed" data-id="element-16">
          Si hoy estás cansada de sentir que cada madrugada te gana…
        </p>

        <p className="text-lg text-cream-100" data-id="element-17">
          no porque seas débil, sino porque estás improvisando sin un plan…
        </p>

        <p className="text-xl font-bold text-amber-500" data-id="element-18">
          Entonces esto es para ti.
        </p>

        <div className="py-8" data-id="element-19">
          <p className="text-lg text-cream-100 mb-2" data-id="element-20">
            No te prometo que no te vas a despertar.
          </p>
          <p className="text-2xl font-serif text-cream-50 italic" data-id="element-21">
            Te prometo que no vas a quedarte sola en la espiral.
          </p>
        </div>

        <Button scrollTo="pricing" variant="secondary" data-id="element-22">
          Obtener el Kit ahora
        </Button>
      </div>
    </Section>;
}